/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiUpdateSocialVersionContentMutationRequest, ContentAiUpdateSocialVersionContentMutationResponse, ContentAiUpdateSocialVersionContentPathParams, ContentAiUpdateSocialVersionContent401, ContentAiUpdateSocialVersionContent403 } from "../models/ContentAiUpdateSocialVersionContent";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { contentAiUpdateSocialVersionContent } from "../axios/contentAiUpdateSocialVersionContent";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const contentAiUpdateSocialVersionContentMutationKey = () => [{ url: '/content-ai/v1/contents/:id/social-version/:platform/update' }] as const

export type ContentAiUpdateSocialVersionContentMutationKey = ReturnType<typeof contentAiUpdateSocialVersionContentMutationKey>

export function contentAiUpdateSocialVersionContentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ContentAiUpdateSocialVersionContentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = contentAiUpdateSocialVersionContentMutationKey()
        return mutationOptions<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, {id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, platform, data }) => {
            return contentAiUpdateSocialVersionContent(id, platform, data, config)
          },
        })

}

/**
 * @summary Update social version before publishing
 * {@link /content-ai/v1/contents/:id/social-version/:platform/update}
 */
export function useContentAiUpdateSocialVersionContent<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, {id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentAiUpdateSocialVersionContentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? contentAiUpdateSocialVersionContentMutationKey()

          const baseOptions = contentAiUpdateSocialVersionContentMutationOptions(config) as UseMutationOptions<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, {id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest}, TContext>
          

          return useMutation<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, {id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ContentAiUpdateSocialVersionContentMutationResponse, ResponseErrorConfig<ContentAiUpdateSocialVersionContent401 | ContentAiUpdateSocialVersionContent403>, {id: ContentAiUpdateSocialVersionContentPathParams["id"], platform: ContentAiUpdateSocialVersionContentPathParams["platform"], data: ContentAiUpdateSocialVersionContentMutationRequest}, TContext>
      
}